import { useFormik } from "formik";
import * as Yup from "yup";

const useRemarkForm = ({ handleYes }) => {
  const initialValues = {
    remark: "",
  };

  const validation = Yup.object({
    remark: Yup.string().matches(/^\S[\s\S]*$/, {
      message: "Remark cannot start with a space",
      excludeEmptyString: true,
    }),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: validation,
    onSubmit: (values) => {
      handleYes(values.remark?.trim());
    },
  });

  return { formik };
};

export default useRemarkForm;
